export function getFilterOptions () {
  return [
    {
      key: 'sn',
      label: 'SN',
      value: 'sn'
    },
    {
      key: 'model',
      label: 'Model',
      value: 'model'
    },
    {
      key: 'online',
      label: 'Status - Online',
      value: 'online'
    },
    {
      key: 'offline',
      label: 'Status - Offline',
      value: 'offline'
    }
  ]
}

export default {
  getFilterOptions
}



// WEBPACK FOOTER //
// ./src/components/Device/helper.js